module.exports = __webpack_public_path__ + "img/alpi.6a569528.jpeg";